import { render, staticRenderFns } from "./Provisionslogtabelle.vue?vue&type=template&id=14002262&scoped=true&"
import script from "./Provisionslogtabelle.vue?vue&type=script&lang=js&"
export * from "./Provisionslogtabelle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14002262",
  null
  
)

export default component.exports